import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=28b43edd&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=28b43edd&prod&lang=scss&scoped=true"
import style1 from "./EventCard.vue?vue&type=style&index=1&id=28b43edd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b43edd",
  null
  
)

export default component.exports